import { Box } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { UseFieldArrayReturn, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { LegacyMuiButton } from '~/legacy-components/LegacyForms';

import { newFormData } from './data/newForm';
import { IFormInput, RowData } from './useForms';
import { useSxStyles } from './useStyles';

export const ActionButtons = ({
  setEditMode,
  setEditedRows,
  setDeletedRows,
  useFormMethods,
  onSubmit,
  defaultData,
  useFieldArrayMethods,
  editMode,
  empId,
  openFormsDialog,
}: {
  setEditMode: Dispatch<SetStateAction<boolean>>;
  onSubmit: () => void;
  setEditedRows: Dispatch<SetStateAction<number[]>>;
  setDeletedRows: Dispatch<SetStateAction<number[]>>;
  useFormMethods: UseFormReturn<IFormInput>;
  defaultData: RowData[];
  useFieldArrayMethods: UseFieldArrayReturn<IFormInput, 'form', 'id'>;
  editMode: boolean;
  empId: string;
  openFormsDialog: () => void;
}) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const { reset } = useFormMethods;
  const { append } = useFieldArrayMethods;

  return (
    <Box sx={{ flexGrow: 1 }}>
      {editMode ? (
        <>
          <LegacyMuiButton
            onClick={() => {
              setEditMode((prevValue) => !prevValue);
              setEditedRows([]);
              setDeletedRows([]);
              reset({
                form: defaultData,
              });
            }}
            startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Close} />}
            sx={sxStyles.button}
          >
            {t('laCancel')}
          </LegacyMuiButton>
          <LegacyMuiButton
            onClick={() => onSubmit()}
            startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Save} />}
            sx={sxStyles.button}
          >
            {t('laSave')}
          </LegacyMuiButton>
          <LegacyMuiButton
            onClick={async () => {
              const newForm = newFormData();
              append(newForm);
            }}
            startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Plus} />}
            sx={sxStyles.button}
          >
            {t('laAdd')}
          </LegacyMuiButton>
        </>
      ) : (
        <>
          <LegacyMuiButton
            onClick={() => setEditMode((prevValue) => !prevValue)}
            startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Edit} />}
            sx={sxStyles.button}
          >
            {t('laEdit')}
          </LegacyMuiButton>
          <LegacyMuiButton
            onClick={() => openFormsDialog()}
            startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.List} />}
            sx={sxStyles.button}
          >
            {t('laForms')}
          </LegacyMuiButton>
        </>
      )}
    </Box>
  );
};
